import { darken, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  button: {
    border: 'none',
    padding: '12px 24px',
    boxShadow: '0px 2px 15px 0px rgba(0, 0, 0, 0.05)',
    backgroundColor: '#2b39b9',
    color: '#fff',
    borderRadius: 4,

    '&:hover': {
      backgroundColor: darken('#2b39b9', 0.3),
    },
  },
  buttonLabel: {
    fontSize: 14,
    lineHeight: '16px',
  },
  textButton: {
    padding: 0,
    borderRadius: 4,

    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  textButtonLabel: {
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: 600,
    color: '#2b39b9',
    textDecoration: 'underline',

    '&:hover': {
      color: darken('#2b39b9', 0.4),
    },
  },
});
